import { CasPurposesApi } from "@jti/rest-api";

export const checkPurpose = async (purposeId: string): Promise<boolean> => {
  try {
    const purposes = await CasPurposesApi.init().getPurposesForUserByCategory("all", true);
    const matchedPurpose = purposes.find((purpose) => purpose.id === purposeId);
    return matchedPurpose ? matchedPurpose.accepted : false;
  } catch (e) {
    console.error("checkPurpose error ==>", e);
    return false;
  }
};
